module.exports = __webpack_public_path__ + "img/Inflammation-CRC_GSE225857.b0a12875.png";